import type { Service, ServiceSlug } from "./types";
import { REVIEW_COUNT_TEXT, GENERIC_BOKADIREKT } from "@/lib/booking";
import herrklippningAsset from "@/assets/opt/herrklippning-tailors-barber.webp";
import taperFadeAsset from "@/assets/opt/taper-fade-tailors-barber.webp";
import skaggAsset from "@/assets/opt/skagg-tailors-barber.webp";
import klippningSkaggAsset from "@/assets/opt/klippning-skagg-tailors-barber.webp";
import barnklippningAsset from "@/assets/opt/barnklippning-tailors-barber.webp";
import slatrakningAsset from "@/assets/slatrakning-tailors-barber.png.asset.json";
const cutImg = herrklippningAsset;
const fadeImg = taperFadeAsset;
const beardImg = skaggAsset;
const cutBeardImg = klippningSkaggAsset;
const kidsImg = barnklippningAsset;
const shaveImg = slatrakningAsset.url;
const BARN_BOKA_URL =
  "https://www.bokadirekt.se/boka-tjanst/tailors-barber-stockholm-ahlens-city-37678/barnklippning-upp-till-10-ar-ej-skinfade-kids-haircut-up-to-10-years-no-skin-fade-1247223";
const BARN_BOKA_TABY = "https://www.bokadirekt.se/boka-tjanst/tailors-barber-taby-centrum-37677/barnklippning-upp-till-10-ar-ej-skinfade-kids-haircut-up-to-10-years-no-skin-fade-1247203";
const BARN_BOKA_ARNINGE = "https://www.bokadirekt.se/boka-tjanst/tailors-barber-arninge-ica-maxi-huset--61598/barnklippning-upp-till-10-ar-ej-skinfade-kids-haircut-up-to-10-years-no-skin-fade-3206951";
const BARN_BOKA_AKERSBERGA = "https://www.bokadirekt.se/boka-tjanst/tailors-barber-akersberga-ica-maxi-huset--37682/barnklippning-upp-till-10-ar-ej-skinfade-kids-haircut-up-to-10-years-no-skin-fade-1247241";
const HERR_BOKA_TABY = "https://www.bokadirekt.se/places/tailors-barber-taby-centrum-37677";
const HERR_BOKA_ARNINGE = "https://www.bokadirekt.se/places/tailors-barber-arninge-ica-maxi-huset--61598";
const HERR_BOKA_AKERSBERGA = "https://www.bokadirekt.se/places/tailors-barber-akersberga-ica-maxi-huset--37682";

export const services: Service[] = [
  {
    slug: "herrklippning",
    url: "/herrklippning",
    name: "Herrklippning för män",
    shortName: "Herrklippning",
    category: "Klippning",
    excerpt:
      "Herrklippning Stockholm 450 kr på fyra salonger: Åhléns City, Täby, Åkersberga och Arninge. Erfarna barberare, drop-in i mån av plats. Boka online.",
    priceFrom: 450,
    durationMin: 45,
    image: cutImg,
    bodyImage: cutImg,
    bodyImageAlt: "Herrklippning Stockholm hos Tailor's Barber",
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid", "amir"],
    relatedServices: ["taper-fade", "skaggtrimning", "herrklippning-skaggtrimning", "slatrakning"],
    seoTitle: "Herrklippning Stockholm: 450 kr för män | Tailor's Barber",
    metaDescription:
      "Herrklippning Stockholm 450 kr på fyra salonger: Åhléns City, Täby, Åkersberga och Arninge. Erfarna barberare, drop-in i mån av plats. Boka online.",
    bookingUrl: GENERIC_BOKADIREKT,
    ctaLabel: "Boka Herrklippning",
    faq: [
      { q: "Hur lång tid tar en herrklippning?", a: "30–45 minuter beroende på frisyr och hårtyp, inklusive konsultation." },
      { q: "Behöver jag boka tid eller går det att komma på drop-in?", a: "Onlinebokning via BokaDirekt rekommenderas. Drop-in finns i mån av plats." },
      { q: "Vad kostar en herrklippning?", a: "450 kr. Inkluderar konsultation, klippning, formning och styling." },
      { q: "Vad ingår i en herrklippning?", a: "Konsultation, klippning med sax eller maskin, nacke och sidor, line-ups och styling." },
      { q: "Gör ni skin fade och taper fade?", a: "Ja — low, mid, high och skin fade, anpassat efter din önskan." },
      { q: "Vad är skillnaden på herrfrisör och barber?", a: "En barberare är specialiserad på herrklipp, fades och skägg. En frisör jobbar bredare med både dam- och herrfrisyrer." },
      { q: "Kan jag få rådgivning om vilken frisyr som passar mig?", a: "Ja, alltid. Vi utgår från hårtyp, ansiktsform och livsstil." },
    ],
  },
  {
    slug: "herrklippning-stockholm",
    url: "/herrklippning-stockholm",
    name: "Herrklippning Stockholm",
    shortName: "Herrklippning Stockholm",
    category: "Klippning",
    excerpt: "Herrklippning i Stockholm på fyra salonger: Åhléns City, Täby, Åkersberga och Arninge. Boka erfarna barberare online.",
    priceFrom: 450,
    durationMin: 45,
    image: cutImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid", "amir"],
    relatedServices: ["herrklippning", "fade", "taper-fade", "har-skagg"],
    seoTitle: "Herrklippning Stockholm: 450 kr på 4 salonger | Tailor's Barber",
    metaDescription:
      `Herrklippning Stockholm hos Tailor's Barber, fyra salonger, 450 kr. ${REVIEW_COUNT_TEXT}. Boka online eller drop-in i mån av plats.`,
    faq: [
      {
        q: "Var i Stockholm kan jag boka herrklippning hos Tailor's Barber?",
        a: "Tailor's Barber har fyra salonger i Stockholm: Åhléns City på Klarabergsgatan 50 i Stockholm City, Täby Centrum, Åkersberga centrum och Arninge Centrum. Alla salonger erbjuder herrklippning för 450 kr och bokas via BokaDirekt.",
      },
      {
        q: "Vilken Tailor's Barber-salong i Stockholm ligger närmast mig?",
        a: "Bor eller jobbar du i innerstan är Åhléns City vid Centralstationen smidigast. För norra Stockholm har vi Täby Centrum, Arninge Centrum och Åkersberga centrum. Använd salongssidan eller geolocation på startsidan för att se avstånd.",
      },
      {
        q: "Vad kostar en herrklippning i Stockholm hos Tailor's Barber?",
        a: "Herrklippning kostar 450 kr i samtliga salonger. Tilläggsbehandlingar som skäggtrim, slätrakning eller färgning prissätts separat enligt vår prislista.",
      },
      {
        q: "Hur lång tid tar en herrklippning?",
        a: "En vanlig herrklippning tar 30–45 minuter inklusive konsultation, klippning med sax och maskin samt styling. Klippning & Skäggtrimning tar 45–60 minuter.",
      },
      {
        q: "Kan jag välja barberare när jag bokar?",
        a: "Ja. Varje barberare har en egen profil på BokaDirekt med kalender och tillgängliga tider. Du kan filtrera på salong, behandling och barberare.",
      },
      {
        q: "Erbjuder ni drop-in på era Stockholm-salonger?",
        a: "Ja, drop-in finns på alla fyra salonger i mån av plats. För garanterad tid rekommenderar vi onlinebokning via BokaDirekt.",
      },
      {
        q: "Vilken är er mest centrala salong i Stockholm?",
        a: "Tailor's Barber Åhléns City på Klarabergsgatan 50, mitt i Åhléns vid T-Centralen. Det är vår mest centrala salong och perfekt för lunchklippning.",
      },
    ],
  },
  {
    slug: "taper-fade",
    url: "/taper-fade",
    name: "Taper fade för män",
    shortName: "Taper Fade",
    category: "Klippning",
    excerpt: "Taper fade i flera varianter: low, mid och high, med skarpa övergångar och rena linjer.",
    priceFrom: 450,
    durationMin: 45,
    image: fadeImg,
    bodyImage: fadeImg,
    bodyImageAlt: "Taper fade Stockholm hos Tailor's Barber",
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid"],
    relatedServices: ["herrklippning", "herrklippning-skaggtrimning", "skaggtrimning"],
    seoTitle: "Taper fade Stockholm: 450 kr, low/mid/high | Tailor's Barber",
    metaDescription:
      "Taper fade i Stockholm hos Tailor's Barber för 450 kr. Low, mid och high fade med skarpa övergångar. Boka erfarna barberare online.",
    bookingUrl: GENERIC_BOKADIREKT,
    ctaLabel: "Boka Taper Fade",
    faq: [
      { q: "Hur lång tid tar en taper fade?", a: "30–45 minuter, inklusive konsultation." },
      { q: "Drop-in eller boka?", a: "Vi rekommenderar bokning för garanterad tid. Drop-in finns i mån av plats." },
      { q: "Vad ingår?", a: "Konsultation, maskin- och saxarbete, rena övergångar, konturer, styling samt tips för hemmastyling." },
      { q: "Gör ni low, mid och high taper fade?", a: "Ja, alla varianter — anpassade efter din stil och hårtyp." },
      { q: "Kan jag kombinera taper fade med skäggtrimning?", a: "Ja, det är ett populärt val. Boka klippning och skäggtrimning i samma session." },
      { q: "Vad är skillnaden mellan taper fade och skin fade?", a: "Taper fade lämnar lite längd kvar längst ner. Skin fade går hela vägen till huden." },
      { q: "Passar taper fade alla hårtyper?", a: "Ja, vi anpassar tekniken efter ditt hår." },
    ],
  },
  {
    slug: "fade",
    url: "/herrfrisyrer-2026",
    name: "Fade Stockholm",
    shortName: "Fade Stockholm",
    category: "Klippning",
    excerpt: "Klassisk fade — skarp, modern och anpassad efter ditt hår och din stil.",
    priceFrom: 450,
    durationMin: 45,
    image: fadeImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid"],
    relatedServices: ["taper-fade", "herrklippning", "har-skagg"],
    seoTitle: "Taper fade Stockholm: 450 kr, low/mid/high | Tailor's Barber",
    metaDescription:
      "Taper fade i Stockholm hos Tailor's Barber för 450 kr. Low, mid och high fade utförda av erfarna barberare. Boka online via BokaDirekt.",
    faq: [
      {
        q: "Vad är skillnaden mellan low, mid och high fade?",
        a: "Skillnaden ligger i var faden börjar. Low fade börjar precis ovanför öronen för ett subtilt uttryck, mid fade i höjd med tinningen ger en balanserad look, och high fade börjar högre upp på sidan av huvudet för ett mer markerat resultat.",
      },
      {
        q: "Vilken fade passar mig?",
        a: "Det beror på ansiktsform, hårtyp och önskat uttryck. Vid bokning får du en kostnadsfri konsultation där vår barberare rekommenderar rätt fade för dig. Skin fade passar bra till skarpa konturer; taper fade fungerar bättre i mer formella miljöer.",
      },
      {
        q: "Hur ofta bör jag klippa om min fade i Stockholm?",
        a: "För att hålla övergången skarp rekommenderar vi var 2–4:e vecka. Många av våra kunder bokar in återkommande tider via BokaDirekt för att slippa boka om varje gång.",
      },
      {
        q: "Vad kostar en fade hos Tailor's Barber?",
        a: "Skin Fade / Taper Fade kostar 450 kr på alla våra Stockholm-salonger: Täby Centrum, Åhléns City, Åkersberga och Arninge.",
      },
      {
        q: "Var i Stockholm gör ni bäst fade?",
        a: "Alla våra barberare är fade-utbildade men flera av våra specialister sitter i Åhléns City. Du ser respektive barberares profil och recensioner direkt i BokaDirekt.",
      },
      {
        q: "Kan jag ta en fade på drop-in?",
        a: "Drop-in finns i mån av plats. Eftersom fade kräver tid och precision rekommenderar vi onlinebokning för garanterad tid.",
      },
    ],
  },
  {
    slug: "har-skagg",
    url: "/herrklippning-skaggtrimning",
    name: "Klippning & Skäggtrimning",
    shortName: "Klippning & Skäggtrim",
    category: "Skägg",
    excerpt: "Komplett behandling — herrklippning och professionell skäggtrimning i samma session.",
    priceFrom: 680,
    durationMin: 60,
    image: cutBeardImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "amir", "jawid"],
    relatedServices: ["herrklippning", "fade", "taper-fade"],
    seoTitle: "Herrklippning & skäggtrimning: 680 kr Stockholm | Tailor's Barber",
    metaDescription:
      "Herrklippning och skäggtrimning i Stockholm för 680 kr. Komplett behandling med form, linjer och styling. Boka online via BokaDirekt.",
    faq: [
      {
        q: "Vad ingår i Klippning & Skäggtrimning?",
        a: "Konsultation, herrklippning, skäggtrimning där skägget formas med sax och trimmer, linjerna markeras med kniv, samt avslutning med varm handduk.",
      },
      {
        q: "Hur lång tid tar behandlingen?",
        a: "45–60 minuter. Vi tar oss tid för konsultation, behandling och styling så att resultatet håller hela vägen tills nästa besök.",
      },
      {
        q: "Vad kostar Klippning & Skäggtrimning i Stockholm?",
        a: "Behandlingen kostar 680 kr i samtliga av våra fyra Stockholm-salonger.",
      },
      {
        q: "Vilken är skillnaden mot att boka klippning och skäggtrim separat?",
        a: "I paketet planerar barberaren klippning och skäggform tillsammans för en balanserad helhet. Det blir både billigare och snabbare än att boka tjänsterna var för sig.",
      },
      {
        q: "Erbjuder ni även slätrakning med rakkniv?",
        a: "Ja. Vi har en separat behandling Klippning & Slätrakning för 680 kr (45–75 min) som kombinerar herrklippning med klassisk slätrakning med rakkniv.",
      },
      {
        q: "Kan jag boka på drop-in?",
        a: "Drop-in finns i mån av plats. Eftersom detta är en längre behandling rekommenderar vi onlinebokning via BokaDirekt för garanterad tid.",
      },
    ],
  },
  {
    slug: "barnklippning",
    directAnswerHeading: "Barnklippning på 30 minuter",
    directAnswer: "Barnklippning kostar 380 kr och tar omkring 25 till 30 minuter. Den gäller barn upp till 10 år. Skin fade ingår inte, vi arbetar med barnanpassade tekniker. Du som förälder sitter gärna med.",
    url: "/barnklippning-stockholm",
    name: "Barnklippning Stockholm",
    shortName: "Barnklippning",
    category: "Barn",
    excerpt: "Barnklippning Stockholm för barn upp till 10 år, 380 kr och omkring 30 minuter. Finns på alla fyra salonger.",
    priceFrom: 380,
    durationMin: 30,
    image: kidsImg,
    bodyImage: kidsImg,
    bodyImageAlt: "Barnklippning Stockholm hos Tailor's Barber",
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["amir", "nick"],
    relatedServices: ["herrklippning", "taper-fade"],
    seoTitle: "Barnklippning Stockholm: 380 kr, barn upp till 10 år | Tailor's Barber",
    metaDescription:
      "Barnklippning i Stockholm för 380 kr, barn upp till 10 år. Säg till vid bokningen om det är första gången eller om barnet är blygt, så anpassar barberaren tempot. Fyra salonger.",
    bookingUrl: BARN_BOKA_URL,
    ctaLabel: "Boka Barnklippning Stockholm",
    faq: [
      { q: "Vad kostar barnklippning i Stockholm?", a: "380 kr för barn upp till 10 år. Samma pris på alla fyra salonger." },
      { q: "Hur lång tid tar en barnklippning?", a: "Omkring 25 till 30 minuter." },
      { q: "Från vilken ålder klipper ni barn?", a: "Vi klipper barn upp till 10 år. Det finns ingen nedre åldersgräns." },
      { q: "Ingår skin fade i barnklippning?", a: "Nej. Vi arbetar med barnanpassade tekniker och skin fade eller taper fade ingår inte." },
      { q: "Kan jag sitta med som förälder?", a: "Ja, och många gör det, särskilt vid första besöket." },
      { q: "Det är första gången mitt barn ska klippa sig, hur gör vi?", a: "Säg till när ni kommer. Barberaren visar verktygen först och förklarar vad som ska hända innan något görs." },
      { q: "Mitt barn är blygt och har svårt att sitta still, går det ändå?", a: "Ja. Berätta det på plats så sänker barberaren tempot och tar pauser. Boka helst tidig förmiddag på vardagar, då är det lugnast." },
      { q: "Hur säger jag hur jag vill ha det klippt?", a: "Beskriv längden i centimeter eller visa en bild. Det är det säkraste sättet att få rätt resultat." },
      { q: "Vilken salong ska jag välja för barnklippning?", a: "Alla fyra erbjuder det. Täby Centrum har störst team och flest lediga tider." },
      { q: "Går det att komma på drop-in med barn?", a: "Ja, i mån av plats. Har barnet svårt att vänta rekommenderar vi bokning, då slipper ni sitta i väntan." },
      { q: "Vad händer om mitt barn inte vill sitta kvar?", a: "Barberaren provar att ta en paus, byta plats eller låta dig hålla barnet i knät. Blir barnet riktigt ledset avbryter vi och bokar hellre om. Hur vi gör med betalningen beror på hur långt vi hunnit, det tar barberaren med dig på plats." },
      { q: "Kan vi komma in och titta innan vi bokar?", a: "Ja, ni får gärna komma in och titta utan att boka. Barnet får se salongen och träffa barberaren, och sedan bestämmer ni er." },
    ],
  },
  {
    slug: "barnklippning-taby",
    directAnswerHeading: "Barnklippning på 30 minuter",
    directAnswer: "Barnklippning kostar 380 kr och tar omkring 25 till 30 minuter. Den gäller barn upp till 10 år. Skin fade ingår inte, vi arbetar med barnanpassade tekniker. Du som förälder sitter gärna med.",
    url: "/barnklippning-taby",
    name: "Barnklippning Täby",
    shortName: "Barnklippning Täby",
    category: "Barn",
    excerpt: "Barnklippning i Täby Centrum för barn upp till 10 år, 380 kr och omkring 30 minuter.",
    priceFrom: 380,
    durationMin: 30,
    image: kidsImg,
    availableAt: ["taby"],
    recommendedBarbers: ["amir", "nick"],
    barberSalon: "taby",
    relatedServices: ["herrklippning", "barnklippning", "taper-fade"],
    seoTitle: "Barnklippning Täby | Barnfrisör Täby Centrum | Tailor's Barber",
    metaDescription:
      "Barnklippning i Täby hos Tailor's Barber på Täby Centrum. Erfarna barberare klipper barn upp till 10 år för 380 kr. Barberaren visar verktygen först och tar pauser om barnet behöver.",
    bookingUrl: BARN_BOKA_TABY,
    ctaLabel: "Boka Barnklippning Täby",
    faq: [
      { q: "Var i Täby ligger Tailor's Barber?", a: "Vi finns inne i Westfield Täby Centrum. Salongen har flera ingångar och är skyltat inne i köpcentret." },
      { q: "Hur tar jag mig till Tailor's Barber i Täby?", a: "Med pendeltåg till Täby C eller med buss. Hållplatsen ligger precis vid Täby Centrum. Med bil finns stor gratis parkering direkt vid köpcentret." },
      { q: "Hur lång tid tar en barnklippning i Täby?", a: "Omkring 25 till 30 minuter. Behöver barnet en paus tar barberaren det." },
      { q: "Vad kostar barnklippning i Täby?", a: "380 kr för barn upp till 10 år." },
      { q: "Ingår taper fade i barnklippning?", a: "Nej. Vi använder barnanpassade tekniker. Taper fade och skin fade ingår inte." },
      { q: "Kan jag som förälder sitta med?", a: "Självklart. Många föräldrar sitter med, särskilt vid första besöket." },
      { q: "Hur bokar jag barnklippning i Täby?", a: "Online via BokaDirekt. Drop-in finns i mån av plats." },
      { q: "Det är första gången mitt barn ska klippa sig, hur gör vi?", a: "Säg till när ni kommer. Barberaren visar verktygen först och förklarar vad som ska hända innan något görs." },
      { q: "Mitt barn är blygt och har svårt att sitta still, går det ändå?", a: "Ja. Berätta det på plats så sänker barberaren tempot och tar pauser. Boka helst tidig förmiddag på vardagar, då är det lugnast." },
      { q: "Hur säger jag hur jag vill ha det klippt?", a: "Beskriv längden i centimeter eller visa en bild. Det är det säkraste sättet att få rätt resultat." },
      { q: "Går det att komma på drop-in med barn?", a: "Ja, i mån av plats. Har barnet svårt att vänta rekommenderar vi bokning, då slipper ni sitta i väntan." },
      { q: "Vad händer om mitt barn inte vill sitta kvar?", a: "Barberaren provar att ta en paus, byta plats eller låta dig hålla barnet i knät. Blir barnet riktigt ledset avbryter vi och bokar hellre om. Hur vi gör med betalningen beror på hur långt vi hunnit, det tar barberaren med dig på plats." },
      { q: "Kan vi komma in och titta innan vi bokar?", a: "Ja, ni får gärna komma in och titta utan att boka. Barnet får se salongen och träffa barberaren, och sedan bestämmer ni er." },
    ],
  },
  {
    slug: "barnklippning-arninge",
    directAnswerHeading: "Barnklippning på 30 minuter",
    directAnswer: "Barnklippning kostar 380 kr och tar omkring 25 till 30 minuter. Den gäller barn upp till 10 år. Skin fade ingår inte, vi arbetar med barnanpassade tekniker. Du som förälder sitter gärna med.",
    url: "/barnklippning-arninge",
    name: "Barnklippning Arninge",
    shortName: "Barnklippning Arninge",
    category: "Barn",
    excerpt: "Barnklippning i Arninge Centrum vid ICA Maxi för barn upp till 10 år, 380 kr.",
    priceFrom: 380,
    durationMin: 30,
    image: kidsImg,
    availableAt: ["arninge"],
    recommendedBarbers: ["amir", "nick"],
    barberSalon: "arninge",
    relatedServices: ["herrklippning", "barnklippning", "taper-fade"],
    seoTitle: "Barnklippning Arninge | Tailor's Barber",
    metaDescription:
      "Barnklippning i Arninge hos Tailor's Barber vid ICA Maxi. Erfarna barberare klipper barn upp till 10 år för 380 kr. Gratis parkering vid salongen. Boka online.",
    bookingUrl: BARN_BOKA_ARNINGE,
    ctaLabel: "Boka Barnklippning Arninge",
    faq: [
      { q: "Var i Arninge ligger Tailor's Barber?", a: "Vi finns i Arninge Centrum intill ICA Maxi. Salongen är skyltat och enkel att hitta." },
      { q: "Hur tar jag mig till Tailor's Barber i Arninge?", a: "Smidigast med bil via E18, med stor gratis parkering direkt vid ICA Maxi Arninge. Även buss från Täby C och Täby Centrum stannar i Arninge." },
      { q: "Hur lång tid tar en barnklippning i Arninge?", a: "Omkring 25 till 30 minuter, lite längre om barnet behöver pauser." },
      { q: "Vad kostar barnklippning i Arninge?", a: "380 kr för barn upp till 10 år." },
      { q: "Ingår taper fade?", a: "Nej. Vi använder barnanpassade tekniker utan fade." },
      { q: "Kan jag sitta med som förälder?", a: "Självklart, gärna vid första besöket." },
      { q: "Hur bokar jag barnklippning i Arninge?", a: "Online via BokaDirekt. Drop-in i mån av plats." },
      { q: "Det är första gången mitt barn ska klippa sig, hur gör vi?", a: "Säg till när ni kommer. Barberaren visar verktygen först och förklarar vad som ska hända innan något görs." },
      { q: "Mitt barn är blygt och har svårt att sitta still, går det ändå?", a: "Ja. Berätta det på plats så sänker barberaren tempot och tar pauser. Boka helst tidig förmiddag på vardagar, då är det lugnast." },
      { q: "Hur säger jag hur jag vill ha det klippt?", a: "Beskriv längden i centimeter eller visa en bild. Det är det säkraste sättet att få rätt resultat." },
      { q: "Går det att komma på drop-in med barn?", a: "Ja, i mån av plats. Har barnet svårt att vänta rekommenderar vi bokning, då slipper ni sitta i väntan." },
      { q: "Vad händer om mitt barn inte vill sitta kvar?", a: "Barberaren provar att ta en paus, byta plats eller låta dig hålla barnet i knät. Blir barnet riktigt ledset avbryter vi och bokar hellre om. Hur vi gör med betalningen beror på hur långt vi hunnit, det tar barberaren med dig på plats." },
      { q: "Kan vi komma in och titta innan vi bokar?", a: "Ja, ni får gärna komma in och titta utan att boka. Barnet får se salongen och träffa barberaren, och sedan bestämmer ni er." },
    ],
  },
  {
    slug: "barnklippning-akersberga",
    directAnswerHeading: "Barnklippning på 30 minuter",
    directAnswer: "Barnklippning kostar 380 kr och tar omkring 25 till 30 minuter. Den gäller barn upp till 10 år. Skin fade ingår inte, vi arbetar med barnanpassade tekniker. Du som förälder sitter gärna med.",
    url: "/barnklippning-akersberga",
    name: "Barnklippning Åkersberga",
    shortName: "Barnklippning Åkersberga",
    category: "Barn",
    excerpt: "Barnklippning i Åkersberga Centrum för barn upp till 10 år, 380 kr och omkring 30 minuter.",
    priceFrom: 380,
    durationMin: 30,
    image: kidsImg,
    availableAt: ["akersberga"],
    recommendedBarbers: ["amir", "nick"],
    barberSalon: "akersberga",
    relatedServices: ["herrklippning", "barnklippning", "taper-fade"],
    seoTitle: "Barnklippning Åkersberga | Tailor's Barber",
    metaDescription:
      "Barnklippning i Åkersberga hos Tailor's Barber. Erfarna barberare klipper barn upp till 10 år för 380 kr. Barberaren tar pauser om barnet behöver. Boka online.",
    bookingUrl: BARN_BOKA_AKERSBERGA,
    ctaLabel: "Boka Barnklippning Åkersberga",
    faq: [
      { q: "Var i Åkersberga ligger Tailor's Barber?", a: "Vi finns i Åkersberga Centrum. Salongen är skyltat och lätt att hitta centralt i Åkersberga." },
      { q: "Hur tar jag mig dit?", a: "Med bil är det enkelt, parkering finns i anslutning till Åkersberga Centrum. Med kollektivtrafik går pendeltåg och buss till Åkersberga." },
      { q: "Hur lång tid tar en barnklippning i Åkersberga?", a: "Omkring 25 till 30 minuter." },
      { q: "Vad kostar barnklippning i Åkersberga?", a: "380 kr för barn upp till 10 år." },
      { q: "Ingår taper fade?", a: "Nej. Vi använder barnanpassade tekniker utan fade." },
      { q: "Kan jag sitta med som förälder?", a: "Självklart." },
      { q: "Hur bokar jag barnklippning i Åkersberga?", a: "Online via BokaDirekt. Drop-in i mån av plats." },
      { q: "Det är första gången mitt barn ska klippa sig, hur gör vi?", a: "Säg till när ni kommer. Barberaren visar verktygen först och förklarar vad som ska hända innan något görs." },
      { q: "Mitt barn är blygt och har svårt att sitta still, går det ändå?", a: "Ja. Berätta det på plats så sänker barberaren tempot och tar pauser. Boka helst tidig förmiddag på vardagar, då är det lugnast." },
      { q: "Hur säger jag hur jag vill ha det klippt?", a: "Beskriv längden i centimeter eller visa en bild. Det är det säkraste sättet att få rätt resultat." },
      { q: "Går det att komma på drop-in med barn?", a: "Ja, i mån av plats. Har barnet svårt att vänta rekommenderar vi bokning, då slipper ni sitta i väntan." },
      { q: "Vad händer om mitt barn inte vill sitta kvar?", a: "Barberaren provar att ta en paus, byta plats eller låta dig hålla barnet i knät. Blir barnet riktigt ledset avbryter vi och bokar hellre om. Hur vi gör med betalningen beror på hur långt vi hunnit, det tar barberaren med dig på plats." },
      { q: "Kan vi komma in och titta innan vi bokar?", a: "Ja, ni får gärna komma in och titta utan att boka. Barnet får se salongen och träffa barberaren, och sedan bestämmer ni er." },
    ],
  },
  {
    slug: "herrklippning-taby" as ServiceSlug,
    url: "/herrklippning-taby",
    name: "Herrklippning Täby",
    shortName: "Herrklippning Täby",
    category: "Klippning",
    excerpt: "Professionell herrklippning i Täby Centrum. Boka tid hos Tailor's Barbers flaggskeppssalong i Westfield Täby Centrum.",
    priceFrom: 450,
    durationMin: 30,
    image: cutImg,
    faq: [
      {
        q: "Var ligger Tailor's Barber i Täby Centrum?",
        a: "Vi finns på Biblioteksgången 1 inne i Westfield Täby Centrum. Följ skyltarna mot övervåningen — vi sitter nära bokhandeln.",
      },
      {
        q: "Hur mycket kostar herrklippning i Täby?",
        a: "En herrklippning kostar 450 kr. Samma pris gäller för skin fade och taper fade. Herr & skägg-paketet (klippning + skäggtrimning) bokas och prissätts via BokaDirekt.",
      },
      {
        q: "Kan jag drop-ina för herrklippning i Täby Centrum?",
        a: "Ja, vi tar emot drop-in i mån av tid. Vill du garantera en specifik tid eller barberare rekommenderar vi bokning via BokaDirekt.",
      },
      {
        q: "Erbjuder ni skin fade och taper fade i Täby?",
        a: "Absolut. Skin fade och taper fade är två av våra mest populära tjänster i Täby Centrum. Våra barberare är specialiserade på fade-tekniker och arbetar med maskin och rakkniv för ett skarpt resultat.",
      },
      {
        q: "Vilka är öppettiderna för Tailor's Barber Täby?",
        a: "Måndag–fredag 10:00–20:00, lördag 10:00–18:00, söndag 10:00–18:00. Vi följer Täby Centrums öppettider med undantag för röda dagar.",
      },
    ],
    availableAt: ["taby"],
    recommendedBarbers: [],
    barberSalon: "taby",
    relatedServices: ["herrklippning-stockholm", "herrklippning-arninge", "herrklippning-akersberga", "taper-fade", "skaggtrimning"],
    seoTitle: "Barberare Täby Centrum: herrklippning 450 kr | Tailor's Barber",
    metaDescription: "Barberare Täby Centrum i Westfield. Herrklippning 450 kr, skin fade, taper fade och skägg. Drop-in välkommet. Boka online.",
    bookingUrl: HERR_BOKA_TABY,
    ctaLabel: "Boka Herrklippning Täby",
  },
  {
    slug: "herrklippning-arninge" as ServiceSlug,
    url: "/herrklippning-arninge",
    name: "Herrklippning Arninge",
    shortName: "Herrklippning Arninge",
    category: "Klippning",
    excerpt: "Herrklippning i Arninge Centrum. Tailor's Barber i ICA Maxi Arninge — professionell klippning med drop-in och tidsbokning.",
    priceFrom: 450,
    durationMin: 30,
    image: cutImg,
    faq: [
      {
        q: "Var ligger Tailor's Barber i Arninge?",
        a: "Vi finns vid Kundvägen 1D i Arninge Centrum, inne i ICA Maxi-området. Parkering finns direkt utanför.",
      },
      {
        q: "Kostar herrklippning i Arninge detsamma som i Stockholm?",
        a: "Ja, samma pris gäller i alla våra salonger. En herrklippning kostar 450 kr oavsett om du bokar i Arninge, Täby, Åkersberga eller Åhléns City.",
      },
      {
        q: "Erbjuder Tailor's Barber Arninge skin fade?",
        a: "Ja, vi erbjuder skin fade, taper fade och klassisk herrklippning. Samma tjänster som i alla våra salonger.",
      },
      {
        q: "Kan man drop-ina i Arninge?",
        a: "Ja, drop-in är välkommen i mån av tid. Öppettider: måndag–fredag 10–19, lördag–söndag 10–18.",
      },
      {
        q: "Hur tar jag mig till Tailor's Barber Arninge utan bil?",
        a: "Arninge nås med buss från Täby Centrum och Vallentuna. Bussarna stannar i Arninge Centrum, nära ICA Maxi.",
      },
    ],
    availableAt: ["arninge"],
    recommendedBarbers: [],
    barberSalon: "arninge",
    relatedServices: ["herrklippning-stockholm", "herrklippning-taby", "herrklippning-akersberga", "taper-fade", "skaggtrimning"],
    seoTitle: "Frisör Arninge: herrklippning 450 kr | Tailor's Barber",
    metaDescription: "Frisör Arninge i ICA Maxi Huset. Herrklippning 450 kr, skin fade, drop-in och tidsbokning. Boka online hos Tailor's Barber.",
    bookingUrl: HERR_BOKA_ARNINGE,
    ctaLabel: "Boka Herrklippning Arninge",
  },
  {
    slug: "herrklippning-akersberga" as ServiceSlug,
    url: "/herrklippning-akersberga",
    name: "Herrklippning Åkersberga",
    shortName: "Herrklippning Åkersberga",
    category: "Klippning",
    excerpt: "Herrklippning i Åkersberga. Tailor's Barber i ICA Maxi Åkersberga — Österåkers enda specialiserade barbershop med fade och drop-in.",
    priceFrom: 450,
    durationMin: 30,
    image: cutImg,
    faq: [
      {
        q: "Var ligger Tailor's Barber i Åkersberga?",
        a: "Vi finns på Långhundravägen 9 inne i ICA Maxi Åkersberga. Gott om gratis parkering direkt utanför.",
      },
      {
        q: "Är Tailor's Barber den enda barbershopen i Åkersberga?",
        a: "Ja, vi är den enda specialiserade barbershopen i Åkersberga och Österåker. Övriga salonger i området är generella hårsalonger.",
      },
      {
        q: "Erbjuder ni skin fade i Åkersberga?",
        a: "Absolut. Skin fade och taper fade är populära tjänster i vår Åkersberga-salong. Våra barberare är specialiserade på fade-tekniker.",
      },
      {
        q: "Hur bokar jag herrklippning i Åkersberga?",
        a: "Boka direkt via BokaDirekt — välj Tailor's Barber Åkersberga, tjänst och tid. Du kan också drop-ina i mån av tid under öppettiderna.",
      },
      {
        q: "Vilka öppettider har Tailor's Barber Åkersberga?",
        a: "Måndag–fredag 10:00–19:00, lördag 10:00–18:00, söndag 10:00–18:00.",
      },
    ],
    availableAt: ["akersberga"],
    recommendedBarbers: [],
    barberSalon: "akersberga",
    relatedServices: ["herrklippning-stockholm", "herrklippning-taby", "herrklippning-arninge", "taper-fade", "skaggtrimning"],
    seoTitle: "Frisör Åkersberga: herrklippning 450 kr | Tailor's Barber",
    metaDescription: "Frisör Åkersberga i ICA Maxi. Herrklippning 450 kr, skin fade, taper fade och drop-in. Boka online hos Tailor's Barber.",
    bookingUrl: HERR_BOKA_AKERSBERGA,
    ctaLabel: "Boka Herrklippning Åkersberga",
  },
  {
    slug: "skin-fade-taby",
    url: "/skin-fade-taby",
    name: "Skin Fade Täby",
    shortName: "Skin Fade",
    category: "Klippning",
    excerpt: "Skin fade Täby Centrum hos Tailor's Barber. Skarp fade från noll vid tinningarna till önskad längd på toppen. Boka erfarna barberare.",
    image: fadeImg,
    bodyImage: fadeImg,
    bodyImageAlt: "Skin fade Täby hos Tailor's Barber",
    priceFrom: 450,
    durationMin: 45,
    faq: [
      { q: "Vad kostar skin fade i Täby?", a: "Skin fade på Tailor's Barber Täby Centrum kostar 450 kr, samma pris som på alla våra salonger. Kombinerar du med skäggtrimning kostar det 680 kr." },
      { q: "Hur ofta behöver jag klippa min skin fade?", a: "För att hålla en skin fade skarp rekommenderar vi klippning var 2–4 vecka beroende på hur snabbt ditt hår växer och hur tajt du vill ha övergångarna." },
      { q: "Kan jag välja hög, mid eller low fade?", a: "Absolut. Berätta för din barberare vilken stil du vill ha — vi hjälper dig att välja baserat på din ansiktsform och hårtyp om du är osäker." },
      { q: "Finns det drop-in för skin fade i Täby?", a: "Vi erbjuder drop-in när platser finns, men för skin fade rekommenderar vi bokning online för att garantera tid hos en erfaren fade-barberare." },
      { q: "Är Tailor's Barber öppet på helger i Täby?", a: "Ja, vi har öppet lördag och söndag i Täby Centrum. Se aktuella öppettider på bokningssidan." },
    ],
    availableAt: ["taby"],
    recommendedBarbers: [],
    barberSalon: "taby",
    relatedServices: ["fade", "taper-fade", "herrklippning-taby"],
    seoTitle: "Skin fade Täby: 450 kr på Täby Centrum | Tailor's Barber",
    metaDescription: "Skin fade Täby hos Tailor's Barber för 450 kr. Skarp precision fade från noll vid tinningarna. Boka erfarna barberare online.",
    bookingUrl: "https://www.bokadirekt.se/places/tailors-barber-taby-centrum-37677",
    ctaLabel: "Boka skin fade i Täby",
  },
  {
    slug: "skin-fade-arninge",
    url: "/skin-fade-arninge",
    name: "Skin Fade Arninge",
    shortName: "Skin Fade",
    category: "Klippning",
    excerpt: "Professionell skin fade på Tailor's Barber Arninge Centrum. Söder om Täby, norr om stan — din närmaste fade-barbershop.",
    image: fadeImg,
    priceFrom: 450,
    durationMin: 45,
    faq: [
      { q: "Erbjuder Tailor's Barber Arninge skin fade?", a: "Ja. Skin fade är en av våra mest bokade tjänster i Arninge. Vi utför den med maskin och rakkniv för en skarp, slät övergång." },
      { q: "Hur nära Täby ligger Arninge-salongen?", a: "Arninge Centrum ligger cirka 5 minuter söder om Täby centrum med bil. Enkelt att nå från Täby, Vallentuna och norra Stockholm." },
      { q: "Hur ofta bör jag klippa min fade?", a: "Var 2–4 vecka beroende på hur snabbt håret växer och hur tajta övergångarna ska vara. Många kunder bokar direkt nästa tid innan de lämnar salongen." },
      { q: "Kan jag kombinera skin fade med skäggtrimning i Arninge?", a: "Ja, vi erbjuder kombinationspaket med klippning och skägg. Berätta vad du vill ha när du bokar eller när du kommer in." },
      { q: "Har ni drop-in i Arninge?", a: "Vi erbjuder drop-in när platser finns. Bokning online rekommenderas för skin fade för att säkra tid hos en fade-barberare." },
    ],
    availableAt: ["arninge"],
    recommendedBarbers: [],
    barberSalon: "arninge",
    relatedServices: ["fade", "taper-fade", "herrklippning-arninge"],
    seoTitle: "Skin Fade Arninge | Tailor's Barber Arninge Centrum",
    metaDescription: "Skin fade på Tailor's Barber Arninge Centrum. Professionell fade med maskin och rakkniv — den enda specialiserade barbershopen i Arninge. Boka online.",
    bookingUrl: "https://www.bokadirekt.se/places/tailors-barber-arninge-ica-maxi-huset--61598",
    ctaLabel: "Boka skin fade i Arninge",
  },
  {
    slug: "skin-fade-akersberga",
    url: "/skin-fade-akersberga",
    name: "Skin Fade Åkersberga",
    shortName: "Skin Fade",
    category: "Klippning",
    excerpt: "Skin fade i Åkersberga — utförd av Tailor's Barber, den enda riktiga barbershopen i Österåker. Sluta åka in till stan.",
    image: fadeImg,
    priceFrom: 450,
    durationMin: 45,
    faq: [
      { q: "Finns det skin fade i Åkersberga?", a: "Ja. Tailor's Barber är den enda barbershopen i Åkersberga som erbjuder professionell skin fade med maskin och rakkniv." },
      { q: "Vad kostar skin fade i Åkersberga?", a: "Skin fade kostar 450 kr, samma pris som på alla våra salonger." },
      { q: "Hur länge håller en skin fade?", a: "En skin fade ser skarpast ut de första 1–2 veckorna. De flesta kunder återkommer var 2–4 vecka för att hålla övergångarna rena." },
      { q: "Kan jag gå dit utan bokning?", a: "Drop-in är möjligt när plats finns. För skin fade rekommenderar vi att boka tid online för att garantera en fade-barberare." },
      { q: "Är ni öppna på helgen i Åkersberga?", a: "Ja, vi har öppet lördag och söndag. Se aktuella tider på bokningssidan." },
    ],
    availableAt: ["akersberga"],
    recommendedBarbers: [],
    barberSalon: "akersberga",
    relatedServices: ["fade", "taper-fade", "herrklippning-akersberga"],
    seoTitle: "Skin Fade Åkersberga | Tailor's Barber Åkersberga",
    metaDescription: "Skin fade i Åkersberga — Tailor's Barber är den enda riktiga barbershopen i Österåker. Professionell fade med maskin och rakkniv. Boka online idag.",
    bookingUrl: "https://www.bokadirekt.se/places/tailors-barber-akersberga-ica-maxi-huset--37682",
    ctaLabel: "Boka skin fade i Åkersberga",
  },
  {
    slug: "drop-in",
    url: "/drop-in-barber-stockholm",
    name: "Drop-in Barber Stockholm",
    shortName: "Drop-in Barber Stockholm",
    category: "Drop-in",
    excerpt: "Behöver du klippning nu? Kom förbi på drop-in i mån av plats.",
    priceFrom: 450,
    durationMin: 30,
    image: cutImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid", "amir"],
    relatedServices: ["herrklippning", "fade", "taper-fade"],
    seoTitle: "Barber Stockholm drop in: 4 salonger | Tailor's Barber",
    metaDescription:
      "Barber Stockholm drop in på fyra salonger. Drop-in i mån av plats: Åhléns City, Täby, Åkersberga, Arninge. För garanterad tid, boka online.",
    faq: [
      {
        q: "Vilka Tailor's Barber-salonger i Stockholm har drop-in?",
        a: "Alla våra fyra salonger erbjuder drop-in i mån av plats: Åhléns City i Stockholm City, Täby Centrum, Åkersberga centrum och Arninge Centrum.",
      },
      {
        q: "Hur funkar drop-in?",
        a: "Du kommer förbi salongen utan föranmälan. Finns det en ledig barberare blir du insläppt direkt — annars får du en uppskattad väntetid. Drop-in i mån av plats. För garanterad tid rekommenderar vi att du bokar online.",
      },
      {
        q: "Hur lång väntetid är det på drop-in?",
        a: "Väntetiden varierar beroende på tid på dygnet och dag. Vardagsförmiddagar och tidiga lunchtider är ofta lugnast; eftermiddagar och helger har högst tryck.",
      },
      {
        q: "Vilken salong har bäst tillgänglighet för drop-in just nu?",
        a: "Det varierar dagligen. Ring gärna salongen innan du åker, eller kolla aktuella tider direkt i BokaDirekt för respektive salong.",
      },
      {
        q: "Vad kostar drop-in?",
        a: "Samma priser som vid onlinebokning — herrklippning 450 kr, Skin Fade / Taper Fade 450 kr, Klippning & Skäggtrimning 680 kr, Skäggtrimning 380 kr, Slätrakning 390 kr.",
      },
      {
        q: "Kan jag boka skäggtrim eller Klippning & Skäggtrimning på drop-in?",
        a: "Ja, alla våra behandlingar är tillgängliga på drop-in i mån av plats. Längre behandlingar bokas dock helst online för garanterad tid.",
      },
      {
        q: "Vilken är er mest centrala drop-in barber i Stockholm?",
        a: "Tailor's Barber Åhléns City på Klarabergsgatan 50, mitt i Stockholm City vid T-Centralen. Perfekt för dig som vill ta en drop-in i samband med lunch eller shopping.",
      },
    ],
  },
  {
    slug: "herrfrisyr",
    url: "/herrfrisyrer-2026",
    name: "Herrfrisyrer 2026 — populära stilar i Stockholm",
    shortName: "Herrfrisyrer",
    category: "Klippning",
    excerpt: "Inspiration och guide till årets mest populära herrfrisyrer hos Tailor's Barber.",
    priceFrom: 450,
    durationMin: 45,
    image: cutImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "nick", "jawid", "amir"],
    relatedServices: ["herrklippning", "fade", "taper-fade", "har-skagg"],
    seoTitle: "Herrfrisyrer 2026 — Inspiration & Stilguide | Tailor's Barber",
    metaDescription:
      "Guide till årets mest populära herrfrisyrer i Stockholm: fade, taper fade, textured crop, slick back. Boka herrklippning hos Tailor's Barber.",
    faq: [
      {
        q: "Vilka är de mest populära herrfrisyrerna 2026?",
        a: "Skin fade, taper fade, textured crop, mid fade med längd på toppen och klassisk slick back är de mest bokade stilarna hos våra barberare just nu.",
      },
      {
        q: "Hur väljer jag rätt herrfrisyr för mitt ansikte?",
        a: "Ansiktsform är viktigast: runt ansikte gynnas av volym på toppen och kortare sidor (t.ex. high fade), avlångt ansikte av mer sidolängd. Vid bokning får du en konsultation där barberaren rekommenderar utifrån hårtyp, ansiktsform och stil.",
      },
      {
        q: "Vad kostar en herrfrisyr hos Tailor's Barber?",
        a: "Herrklippning kostar 450 kr. Vill du kombinera med skäggtrim blir det 680 kr (Klippning & Skäggtrimning).",
      },
      {
        q: "Var kan jag boka herrfrisyr i Stockholm?",
        a: "På någon av våra fyra salonger: Täby Centrum, Åhléns City, Åkersberga och Arninge. Boka online via BokaDirekt.",
      },
    ],
  },
  {
    slug: "herrklippning-skaggtrimning",
    url: "/herrklippning-skaggtrimning",
    name: "Herrklippning & Skäggtrimning",
    shortName: "Klippning & Skäggtrim",
    category: "Skägg",
    excerpt: "En komplett behandling för hår och skägg — klippning, skäggform, linjer och styling i samma session.",
    priceFrom: 680,
    durationMin: 60,
    image: cutBeardImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "amir", "jawid"],
    relatedServices: ["taper-fade", "herrklippning", "skaggtrimning", "slatrakning"],
    seoTitle: "Herrklippning & Skäggtrimning för män – Tailor's Barber",
    metaDescription:
      "Herrklippning & skäggtrimning i en komplett behandling. Form, linjer och styling av erfarna barberare. Boka tid hos Tailor's Barber.",
    bookingUrl: GENERIC_BOKADIREKT,
    ctaLabel: "Boka Herrklippning & Skäggtrimning",
    faq: [
      { q: "Hur lång tid tar behandlingen?", a: "Cirka 60 minuter (45–60 min beroende på hår och skägg)." },
      { q: "Vad kostar herrklippning & skäggtrimning?", a: "680 kr — paketpris." },
      { q: "Vad ingår?", a: "Konsultation, klippning, skäggtrimning, linjer och konturer samt styling." },
      { q: "Hur ofta bör man boka?", a: "Var 3–5:e vecka för att hålla både hår och skägg i form." },
      { q: "Gör ni skin fade och taper fade?", a: "Ja, kombineras gärna med skäggtrimning för en komplett look." },
      { q: "Kan jag lägga till rakning med kniv?", a: "Ja, som tillägg." },
      { q: "Får jag tips på produkter?", a: "Ja, alltid — anpassat efter både hår och skägg." },
    ],
  },
  {
    slug: "skaggtrimning",
    url: "/skaggtrimning",
    name: "Skäggtrimning Stockholm",
    shortName: "Skäggtrimning",
    category: "Skägg",
    excerpt:
      "Skäggtrimning Stockholm 380 kr på fyra salonger. Form, linjer och styling anpassad efter ansiktsform och skäggväxt. Boka online eller drop-in.",
    priceFrom: 380,
    durationMin: 30,
    image: beardImg,
    bodyImage: beardImg,
    bodyImageAlt: "Skäggtrimning Stockholm hos Tailor's Barber",
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "amir", "jawid"],
    relatedServices: ["taper-fade", "herrklippning-skaggtrimning", "herrklippning", "slatrakning"],
    seoTitle: "Skäggtrimning Stockholm 380 kr | Tailor's Barber",
    metaDescription:
      "Skäggtrimning i Stockholm för 380 kr hos Tailor's Barber. Form, linjer, rakkniv och styling på våra fyra salonger. Boka online eller kom på drop-in.",
    bookingUrl: GENERIC_BOKADIREKT,
    ctaLabel: "Boka Skäggtrimning",
    faq: [
      { q: "Hur lång tid tar en skäggtrimning?", a: "20 till 30 minuter beroende på längd och formning." },
      { q: "Vad kostar skäggtrimning i Stockholm?", a: "380 kr. Priset inkluderar formning, konturer, mustaschtrimning och putsning, och gäller på alla våra fyra salonger." },
      { q: "Kan jag komma på drop-in?", a: "Ja, men onlinebokning rekommenderas för säker plats." },
      { q: "Ingår rakning av hals och kinder?", a: "Ja, alltid." },
      { q: "Ingår mustaschtrimning?", a: "Ja, alltid om du önskar." },
      { q: "Använder ni rakkniv?", a: "Ja, vid behov för extra skarpa linjer, ofta tillsammans med varm handduk." },
      { q: "Kan jag kombinera skäggtrimning med herrklippning?", a: "Ja, hår och skägg kostar 680 kr och är vår mest bokade kombination." },
      { q: "Är det värt att trimma skägget hos en barberare?", a: "Ja, du får symmetri, renare linjer och en form som är anpassad efter din ansiktsform, något som är svårt att träffa rätt på hemma." },
      { q: "Hur långt skägg behöver man ha?", a: "Det räcker med 1 till 2 veckors växt. Vi kan forma och trimma oavsett utgångsläge." },
      { q: "Hur ofta bör jag trimma skägget?", a: "Varannan till var tredje vecka för korta skägg, var tredje till fjärde vecka för längre skägg." },
      { q: "Vad är skillnaden mellan en vanlig trimning och skäggtrimning med styling?", a: "En vanlig trimning kortar längden. Hos oss formas skägget efter ansiktsform och växtriktning, linjerna sätts med rakkniv och behandlingen avslutas med olja, balm eller vax." },
      { q: "Vilka produkter använder ni?", a: "Vi arbetar med skäggolja, balm och vax och rekommenderar produkter utifrån din skäggtyp. Produkterna finns även att köpa i salongen." },
      { q: "Vilka salonger gör skäggtrimning?", a: "Alla fyra: Åhléns City, Täby Centrum, Åkersberga och Arninge. Samma pris gäller överallt." },
    ],

  },
  {
    slug: "slatrakning",
    url: "/slatrakning",
    name: "Slätrakning med rakkniv",
    shortName: "Slätrakning",
    category: "Skägg",
    excerpt: "Klassisk slätrakning med rakkniv för ett nära, lent resultat — inklusive varm handduk och återfuktande finish.",
    priceFrom: 390,
    durationMin: 30,
    image: shaveImg,
    availableAt: ["ahlens-city", "taby", "akersberga", "arninge"],
    recommendedBarbers: ["neo", "amir", "jawid"],
    relatedServices: ["skaggtrimning", "herrklippning-skaggtrimning", "herrklippning"],
    seoTitle: "Slätrakning med rakkniv – Klassisk barberarrakning i Stockholm",
    metaDescription:
      "Boka slätrakning med rakkniv hos Tailor's Barber. Traditionell rakning med varm handduk, nära resultat och skarpa linjer. Fyra salonger i Stockholm.",
    bookingUrl: GENERIC_BOKADIREKT,
    ctaLabel: "Boka Slätrakning",
    faq: [
      { q: "Hur lång tid tar en slätrakning?", a: "Cirka 30 minuter, inklusive förberedelse med varm handduk och finish." },
      { q: "Vad kostar en slätrakning?", a: "390 kr." },
      { q: "Ingår varm handduk?", a: "Ja, varm handduk ingår alltid för att mjuka upp hud och skägg." },
      { q: "Använder ni rakkniv?", a: "Ja, vi rakar med klassisk rakkniv för bästa resultat." },
      { q: "Kan jag boka slätrakning tillsammans med klippning?", a: "Ja — välj Klippning & Slätrakning på BokaDirekt för en komplett behandling." },
      { q: "Passar slätrakning känslig hud?", a: "Ja, vi anpassar teknik och produkter efter din hudtyp. Meddela barberaren om du har känslig eller irritationsbenägen hud." },
      { q: "Hur länge håller resultatet?", a: "Vanligtvis 1–2 dagar längre än en maskinrakning, beroende på skäggväxt." },
    ],
  },
];

export const serviceBySlug = Object.fromEntries(services.map((s) => [s.slug, s])) as Record<
  string,
  Service
>;

export const serviceByUrl = Object.fromEntries(services.map((s) => [s.url, s])) as Record<
  string,
  Service
>;

export const popularServiceSlugs: Service["slug"][] = [
  "herrklippning-stockholm",
  "fade",
  "taper-fade",
  "har-skagg",
  "barnklippning",
  "drop-in",
];

/**
 * Full salon price menu — the canonical price list shown to customers.
 * Source of truth for prices. Keep in sync with BokaDirekt.
 */
export interface MenuItem {
  name: string;
  /** Price in SEK. Omit when price varies / "Se pris på BokaDirekt". */
  priceKr?: number;
  /** Duration label, e.g. "30 min" or "30–45 min". */
  duration: string;
  description: string;
  /** Optional link to related service landing page. */
  serviceSlug?: ServiceSlug;
}

export interface MenuCategory {
  id: string;
  title: string;
  items: MenuItem[];
}



export const priceMenu: MenuCategory[] = [
  {
    id: "harklippning",
    title: "Hårklippning",
    items: [
      {
        name: "Herrklippning",
        priceKr: 450,
        duration: "30–45 min",
        description:
          "Professionell herrklippning anpassad efter din hårtyp, stil och ansiktsform. Endast herrfrisyrer.",
        serviceSlug: "herrklippning",
      },
      {
        name: "Skin Fade / Taper Fade",
        priceKr: 450,
        duration: "30–45 min",
        description:
          "En modern fade med mjuka övergångar från kort till längre hår. Perfekt för dig som vill ha en skarp, ren och stilren look.",
        serviceSlug: "taper-fade",
      },
      {
        name: "Barnklippning",
        priceKr: 380,
        duration: "30 min",
        description:
          "Herrklippning för barn upp till 10 år. Observera att skin fade inte ingår i denna behandling.",
        serviceSlug: "barnklippning",
      },
      {
        name: "Seniorklippning 65+",
        priceKr: 270,
        duration: "30 min",
        description: "Gäller måndag–torsdag mellan kl. 10:00–14:00.",
      },
      {
        name: "Signature Cut",
        priceKr: 840,
        duration: "60 min",
        description:
          "En premiumbehandling för dig som vill ha extra tid, noggrann konsultation och ett skräddarsytt resultat.",
      },
    ],
  },
  {
    id: "skagg-rakning",
    title: "Skäggvård & Rakning",
    items: [
      {
        name: "Klippning & Skäggtrimning",
        priceKr: 680,
        duration: "45–60 min",
        description: "Komplett behandling med herrklippning och professionell skäggtrimning.",
        serviceSlug: "har-skagg",
      },
      {
        name: "Skäggtrimning",
        priceKr: 380,
        duration: "30 min",
        description:
          "Skäggtrim med styling för dig som vill behålla mer längd än en vanlig trimmer tillåter. Skägget formas med sax och trimmer, linjerna markeras med kniv och behandlingen avslutas med varm handduk.",
      },
      {
        name: "Skäggtrimning & Snagg",
        priceKr: 500,
        duration: "45 min",
        description:
          "Kombinerar maskinklippning med skäggtrimning för en välvårdad och enhetlig look.",
      },
      {
        name: "Klippning & Slätrakning",
        priceKr: 680,
        duration: "45–75 min",
        description: "Herrklippning kombinerad med klassisk slätrakning med rakkniv.",
      },
      {
        name: "Slätrakning",
        priceKr: 390,
        duration: "30 min",
        description:
          "Traditionell rakning med rakkniv både med- och mothårs för ett så nära resultat som möjligt. Inkluderar varm handduk.",
        serviceSlug: "slatrakning",
      },
    ],
  },
  {
    id: "vaxning",
    title: "Vaxning",
    items: [
      {
        name: "Vaxning Näsa & Öron",
        priceKr: 150,
        duration: "15 min",
        description: "Effektiv borttagning av oönskad hårväxt i näsa och öron.",
      },
    ],
  },
  {
    id: "behandlingar",
    title: "Behandlingar",
    items: [
      {
        name: "Ögonbrynsfärgning för män",
        priceKr: 170,
        duration: "15 min",
        description:
          "Diskret färgning som framhäver ögonbrynens form och ger ett mer definierat uttryck.",
      },
      {
        name: "Färgning med klipp",
        duration: "60 min",
        description: "Professionell hårfärgning kombinerad med herrklippning.",
      },
      {
        name: "Endast Färgning",
        duration: "45 min",
        description: "Hårfärgning utan klippning.",
      },
      {
        name: "Färgning Skägg & Skäggtrimning",
        duration: "60 min",
        description: "Skäggfärgning kombinerad med professionell trimning och formning.",
      },
      {
        name: "Färgning Skägg",
        priceKr: 395,
        duration: "30 min",
        description:
          "För dig som vill täcka gråa hårstrån eller skapa ett fylligare och mer enhetligt skägg.",
      },
      {
        name: "Öronljusbehandling",
        priceKr: 590,
        duration: "30 min",
        description:
          "En avslappnande behandling som hjälper till att mjuka upp och avlägsna öronvax. Kan bidra till att minska känslan av lock för öronen, susljud och nedsatt hörsel orsakad av vaxproppar.",
      },
      {
        name: "Mjäll- & Torr Hårbottenbehandling",
        duration: "15 min",
        description:
          "Behandling som hjälper till att återfukta hårbotten och minska besvär med mjäll och torrhet.",
      },
    ],
  },
];
